import { BtvProgramme, RBAssetEntityType } from '../../types';

function isBtvProgrammeItem(item: any): item is BtvProgramme {
    return item.entityType === RBAssetEntityType.BtvProgramme;
}

export default isBtvProgrammeItem;
